// extracted by mini-css-extract-plugin
module.exports = {"assignedToContainer":"content_assignedToContainer__2woVt"};